// extracted by mini-css-extract-plugin
module.exports = {"widgetApp":"widget_widgetApp__3gZmY"};